<mat-drawer-container autosize class="mat-typography flex-column" title=''>

  <mat-drawer #drawerFilters mode="over" position="end" class="drawer">
    <mat-drawer-content>
      <div class="top-panel flex-row align-center">
        <div>
          <h2 class="font1 bold">Filter receipts</h2>
        </div>
        <div class="text-right">
          <lib-button variant="icon" (buttonClick)="drawerFilters.toggle()" icon="close" tooltip="Close"></lib-button>
        </div>
      </div>

      <form (ngSubmit)="onSubmit()" [formGroup]="form">

        <div class="flex-row gap-24">
          <mat-form-field>
            <mat-label>Phone Number</mat-label>
            <input matInput type="text" placeholder="" formControlName="userPhoneNo">
          </mat-form-field>
          <mat-form-field>
            <mat-label>Id</mat-label>
            <input matInput type="text" placeholder="" formControlName="id">
          </mat-form-field>
        </div>

        <div class="flex-row gap-24">
          <mat-form-field>
            <mat-label>Scanned after</mat-label>
            <input matInput type="text" [matDatepicker]="createDateGreaterThan" placeholder=""
              formControlName="createDateGreaterThan">
            <mat-datepicker-toggle matSuffix [for]="createDateGreaterThan"></mat-datepicker-toggle>
            <mat-datepicker #createDateGreaterThan></mat-datepicker>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Hour</mat-label>
            <input matInput type="text" [ngxMatTimepicker]="createTimeGreaterThan" placeholder="" [format]="24"
              formControlName="createTimeGreaterThan" [disableClick]="!form.value.createDateGreaterThan"
              (click)="onTimePickerTryOpen(!form.value.createDateGreaterThan)" readonly>
            <ngx-mat-timepicker #createTimeGreaterThan></ngx-mat-timepicker>
            <ngx-mat-timepicker-toggle matSuffix [for]="createTimeGreaterThan"
              [disabled]="!form.value.createDateGreaterThan"
              (click)="onTimePickerTryOpen(!form.value.createDateGreaterThan)">
              <mat-icon ngxMaterialTimepickerToggleIcon>access_time</mat-icon>
            </ngx-mat-timepicker-toggle>
          </mat-form-field>
        </div>

        <div class="flex-row gap-24">
          <mat-form-field>
            <mat-label>Scanned before</mat-label>
            <input matInput type="text" [matDatepicker]="createDateLessThan" placeholder=""
              formControlName="createDateLessThan">
            <mat-datepicker-toggle matSuffix [for]="createDateLessThan"></mat-datepicker-toggle>
            <mat-datepicker #createDateLessThan></mat-datepicker>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Hour</mat-label>
            <input matInput type="text" [ngxMatTimepicker]="createTimeLessThan" placeholder="" [format]="24"
              formControlName="createTimeLessThan" [disableClick]="!form.value.createDateLessThan"
              (click)="onTimePickerTryOpen(!form.value.createDateLessThan)" readonly>
            <ngx-mat-timepicker #createTimeLessThan></ngx-mat-timepicker>
            <ngx-mat-timepicker-toggle matSuffix [for]="createTimeLessThan" [disabled]="!form.value.createDateLessThan"
              (click)="onTimePickerTryOpen(!form.value.createDateLessThan)">
              <mat-icon ngxMaterialTimepickerToggleIcon>access_time</mat-icon>
            </ngx-mat-timepicker-toggle>
          </mat-form-field>
        </div>

        <div class="flex-row gap-24">
          <mat-form-field>
            <mat-label>Invoice date after</mat-label>
            <input matInput type="text" [matDatepicker]="invoiceDateGreaterThan" placeholder=""
              formControlName="invoiceDateGreaterThan">
            <mat-datepicker-toggle matSuffix [for]="invoiceDateGreaterThan"></mat-datepicker-toggle>
            <mat-datepicker #invoiceDateGreaterThan></mat-datepicker>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Hour</mat-label>
            <input matInput type="text" [ngxMatTimepicker]="invoiceTimeGreaterThan" placeholder="" [format]="24"
              formControlName="invoiceTimeGreaterThan" [disableClick]="!form.value.invoiceDateGreaterThan"
              (click)="onTimePickerTryOpen(!form.value.invoiceDateGreaterThan)" readonly>
            <ngx-mat-timepicker #invoiceTimeGreaterThan></ngx-mat-timepicker>
            <ngx-mat-timepicker-toggle matSuffix [for]="invoiceTimeGreaterThan"
              [disabled]="!form.value.invoiceDateGreaterThan"
              (click)="onTimePickerTryOpen(!form.value.invoiceDateGreaterThan)">
              <mat-icon ngxMaterialTimepickerToggleIcon>access_time</mat-icon>
            </ngx-mat-timepicker-toggle>
          </mat-form-field>
        </div>

        <div class="flex-row gap-24">
          <mat-form-field>
            <mat-label>Invoice date before</mat-label>
            <input matInput type="text" [matDatepicker]="invoiceDateLessThan" placeholder=""
              formControlName="invoiceDateLessThan">
            <mat-datepicker-toggle matSuffix [for]="invoiceDateLessThan"></mat-datepicker-toggle>
            <mat-datepicker #invoiceDateLessThan></mat-datepicker>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Hour</mat-label>
            <input matInput type="text" [ngxMatTimepicker]="invoiceTimeLessThan" placeholder="" [format]="24"
              formControlName="invoiceTimeLessThan" [disableClick]="!form.value.invoiceDateLessThan"
              (click)="onTimePickerTryOpen(!form.value.invoiceDateLessThan)" readonly>
            <ngx-mat-timepicker #invoiceTimeLessThan></ngx-mat-timepicker>
            <ngx-mat-timepicker-toggle matSuffix [for]="$any(invoiceTimeLessThan)"
              [disabled]="!form.value.invoiceDateLessThan"
              (click)="onTimePickerTryOpen(!form.value.invoiceDateLessThan)">
              <mat-icon ngxMaterialTimepickerToggleIcon>access_time</mat-icon>
            </ngx-mat-timepicker-toggle>
          </mat-form-field>
        </div>

        <div class="flex-row gap-24">
          <mat-form-field>
            <mat-label>Fraud Result</mat-label>
            <mat-select placeholder="" formControlName="isDuplicate" [compareWith]="compareBoolFn">
              <mat-option [value]="''">Any</mat-option>
              <mat-option [value]="'true'">Yes</mat-option>
              <mat-option [value]="'false'">No</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Fraud Suspect Result</mat-label>
            <mat-select placeholder="" formControlName="isDuplicateSuspect" [compareWith]="compareBoolFn">
              <mat-option [value]="''">Any</mat-option>
              <mat-option [value]="'true'">Yes</mat-option>
              <mat-option [value]="'false'">No</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="flex-row gap-24">
          <mat-form-field>
            <mat-label>Stages</mat-label>
            <mat-select placeholder="" formControlName="stages" multiple>
              <mat-option [value]="'NotRecognizable'">Not recognizable</mat-option>
              <mat-option [value]="'VerifyDuplicate'">Veryfi duplication</mat-option>
              <mat-option [value]="'SuspectDuplicate'">Suspect duplicated</mat-option>
              <mat-option [value]="'SuspectLocation'">Suspect location</mat-option>
              <mat-option [value]="'TimeConstraintNotValid'">Time constraint not valid</mat-option>
              <mat-option [value]="'CurrencyConstraintNotPass'">Currency constraint not pass</mat-option>
              <mat-option [value]="'NotEligible'">Not eligible</mat-option>
              <mat-option [value]="'Incomplete'">Incomplete</mat-option>
              <mat-option [value]="'NotEnoughStamps'">Not enough stamps</mat-option>
              <mat-option [value]="'Eligible'">Eligible</mat-option>
              <mat-option [value]="'ToManualVerify'">Forced manual review</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Suspect duplicate group</mat-label>
            <input matInput type="text" placeholder="" formControlName="suspectDuplicateGroup">
          </mat-form-field>
        </div>

        <lib-multi-labels formControlName="invoiceIds" name="invoiceIds"
          [placeholder]="'Invoice IDs'"></lib-multi-labels>

        <lib-multi-labels formControlName="tags" name="tags" [placeholder]="'Tags'"
          [availableLabelsQuery]="availableLabels()"></lib-multi-labels>

        <lib-multi-labels formControlName="campaigns" name="campaigns"
          [placeholder]="'Campaign Display Names'"></lib-multi-labels>

        <div form-actions class="actions gap-8">
          <lib-button type="submit" variant="raised" [disabled]="!form.valid">Search</lib-button>
          <lib-button type="reset" variant="stroked" (buttonClick)="onReset()">Reset</lib-button>
        </div>
      </form>

    </mat-drawer-content>
  </mat-drawer>
</mat-drawer-container>